import currencies from "@/consts/currencies"
import i18n from "@/i18n"

export const useApproveWindowColumns = () => {
  const columns = [
    {
      title: i18n.t("synchronization.offers_titles.code"),
      scopedSlots: { customRender: "code" },
      dataIndex: "code"
    },
    {
      slots: { title: "warrantyTitle" },
      scopedSlots: { customRender: "warrantyRenderer" },
      dataIndex: "warranty"
    },
    {
      title: i18n.t("synchronization.offers_titles.quantity"),
      scopedSlots: { customRender: "quantity" },
      dataIndex: "quantity"
    },
    {
      title: i18n.t("synchronization.offers_titles.price", { currency: currencies.uk.label }),
      scopedSlots: { customRender: "price" },
      dataIndex: "price"
    },
    {
      width: 30,
      scopedSlots: { customRender: "props" }
    },
    {
      title: i18n.t("synchronization.offers_titles.status"),
      width: 100,
      scopedSlots: { customRender: "state" },
      dataIndex: "is_active"
    },
    {
      width: 160,
      scopedSlots: { customRender: "actions" }
    }
  ]

  return { columns }
}
